package dev.kuml.portal.web

import io.kvision.BootstrapModule
import io.kvision.CoreModule
import io.kvision.Hot
import io.kvision.startApplication

public fun main() {
    startApplication(
        ::PortalApp,
        js("import.meta.webpackHot").unsafeCast<Hot?>(),
        BootstrapModule,
        CoreModule,
    )
}
